import React from "react";

export function Button({ variant = "primary", size = "md", className = "", children, ...props }) {
  const base = "inline-flex items-center justify-center gap-2 font-heading font-bold focus-ring transition-transform duration-150 active:translate-y-[2px] disabled:opacity-50 disabled:pointer-events-none select-none";
  const sizes = {
    sm: "text-sm px-4 py-2 rounded-xl",
    md: "text-base px-6 py-3 rounded-2xl",
    lg: "text-lg px-8 py-4 rounded-full",
  };
  const variants = {
    primary: "bg-primary text-white shadow-claybtn hover:brightness-105 active:shadow-none",
    coral: "bg-coral text-white shadow-coral hover:brightness-105 active:shadow-none",
    sunny: "bg-sunny text-sunny-fg shadow-sunny hover:brightness-105 active:shadow-none",
    outline: "bg-white text-ink border-2 border-slate-200 hover:border-primary/50 shadow-sm",
    ghost: "bg-transparent text-ink-soft hover:bg-slate-100",
    dark: "bg-ink text-white hover:brightness-125",
  };
  return (
    <button className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} {...props}>
      {children}
    </button>
  );
}

export function Card({ kid = false, className = "", children, ...props }) {
  const style = kid
    ? "bg-white border-2 border-primary/20 shadow-clay rounded-4xl"
    : "bg-white border border-slate-200 shadow-soft rounded-3xl";
  return <div className={`${style} ${className}`} {...props}>{children}</div>;
}

export function Input({ label, className = "", ...props }) {
  return (
    <label className="block">
      {label && <span className="block mb-1.5 text-xs font-bold uppercase tracking-[0.15em] text-ink-soft">{label}</span>}
      <input
        className={`w-full rounded-2xl border-2 border-slate-200 bg-white px-4 py-3 text-ink font-medium placeholder:text-ink-muted focus-ring focus:border-primary/50 transition-colors ${className}`}
        {...props}
      />
    </label>
  );
}

export function Modal({ open, onClose, title, children, testid }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center p-0 sm:p-6" data-testid={testid}>
      <div className="absolute inset-0 bg-ink/40 backdrop-blur-sm" onClick={onClose} />
      <div className="relative w-full sm:max-w-lg bg-white rounded-t-4xl sm:rounded-4xl border border-slate-200 shadow-2xl p-6 max-h-[90vh] overflow-y-auto no-scrollbar animate-pop">
        {title && (
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-heading font-extrabold text-ink">{title}</h3>
            <button onClick={onClose} className="text-ink-muted hover:text-ink text-2xl leading-none" data-testid="modal-close" aria-label="Close">×</button>
          </div>
        )}
        {children}
      </div>
    </div>
  );
}

export function Pill({ children, tone = "primary", className = "" }) {
  const tones = {
    primary: "bg-primary/10 text-primary-dark",
    sunny: "bg-sunny/20 text-sunny-fg",
    coral: "bg-coral/15 text-coral-dark",
    slate: "bg-slate-100 text-ink-soft",
  };
  return <span className={`inline-flex items-center gap-1 rounded-full px-3 py-1 text-xs font-bold ${tones[tone]} ${className}`}>{children}</span>;
}

export function Coins({ amount, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-1 font-heading font-extrabold ${className}`}>
      <span className="grid place-items-center w-5 h-5 rounded-full bg-sunny text-sunny-fg text-[11px] leading-none shadow-sm">c</span>
      {amount}
    </span>
  );
}
